// In app browser の判定

const inNativeAppRegex = /\s+com\.(sa-nu|sanu-dev)\.2h/;

export function isInNativeApp(userAgentString: string) {
  return inNativeAppRegex.test(userAgentString);
}

// アプリへのメッセージ送信

// TODO: モノレポ化したら nativeapp と共通化したい
export type WebViewMessageData =
  | {
      type: "ReservationCreate";
      payload:
        | {
            reservationId: string;
          }
        | {
            case: "GeneralError";
          };
    }
  | {
      type: "ReservationChange";
      payload:
        | {
            reservationId: string;
          }
        | {
            case: "GeneralError";
          };
    }
  | {
      type: "ReservationCancel";
      payload:
        | {
            reservationId: string;
          }
        | {
            case: "GeneralError";
          };
    }
  | {
      type: "OneMoreCabinCreate";
      payload:
        | {
            reservationId: string;
          }
        | {
            case: "GeneralError";
          };
    }
  | {
      type: "OneMoreCabinChange";
      payload:
        | {
            reservationId: string;
          }
        | {
            case: "GeneralError";
          };
    }
  | {
      type: "FacilityReservationCreate";
      payload: { id: string } | { case: "GeneralError" };
    }
  | {
      type: "FacilityReservationCancel";
      payload: { id: string } | { case: "GeneralError" };
    }
  | {
      type: "AccountDelete";
    }
  | {
      type: "OpenExternalBrowser";
      payload: {
        url: string;
      };
    }
  | {
      // ネイティブ側で RN WebView 画面を開いて URL を表示する（Safari View ではない）。
      // OpenExternalBrowser と異なり、呼び出し元の WebView は閉じずに上に重ねて開く。
      // presentation で表示方法を指定できる（省略時はネイティブ側で "card"）。
      // title はネイティブ側 WebView 画面のヘッダーに表示する（省略時は空欄）。
      type: "OpenInWebView";
      payload: {
        url: string;
        presentation?: "modal" | "fullScreenModal" | "card";
        title?: string;
      };
    }
  | {
      // WebView を閉じる汎用メッセージ。トースト等は表示しない（呼び出し側で必要なら別途処理）。
      type: "CloseWebView";
    }
  | {
      // 滞在のフィードバックを閉じる。予約の表示を取り直せるよう、送信したかを伝える
      type: "CloseStayReview";
      payload: { submitted: boolean };
    }
  | {
      // WebView のセッションが切れた。ネイティブ側でセッションを取り直して開き直す
      type: "WebViewSessionExpired";
    }
  | {
      // 滞在のフィードバックを表示できた。ネイティブ側の閉じるボタンを消し、web 側の × に任せる
      type: "StayReviewReady";
    };

/** Android の戻るなど、ネイティブ側から閉じたいときに WebView へ送るイベント名 */
export const NATIVE_CLOSE_REQUEST_EVENT = "sanu:native-close-request";

export function postMessageToNativeApp(
  message: WebViewMessageData,
  window: Window,
) {
  window["ReactNativeWebView"]?.postMessage(JSON.stringify(message));
}

/**
 * WebView のセッション（15 分）が切れたことをアプリに知らせる。取り直せるのはアプリのログインを持つアプリ側だけなので、
 * 通信が未ログインで返ったら（isUnauthenticatedError）これを呼ぶ。アプリはセッションを取り直してページを開き直す
 */
export function notifyWebViewSessionExpired(window: Window) {
  postMessageToNativeApp({ type: "WebViewSessionExpired" }, window);
}
